import { Seo } from "@/components/Seo";
import { WHATSAPP_LINK, WHATSAPP_NUMBER } from "@/data/content";

const PRIVACY = {
  title: "Politique de confidentialité",
  seo: {
    title: "Politique de confidentialité — Koranex",
    description: "Comment Koranex collecte, utilise et protège vos données personnelles via son formulaire de contact.",
  },
  sections: [
    {
      h: "Données collectées",
      p: "Lorsque vous utilisez notre formulaire de demande de devis, nous collectons les informations que vous nous transmettez : nom, prénom, nom de l'entreprise (facultatif), adresse e-mail, numéro de téléphone (facultatif), pays, service recherché, budget indicatif (facultatif), description du projet et délai souhaité (facultatif).",
    },
    {
      h: "Finalité du traitement",
      p: "Ces données sont utilisées uniquement pour étudier votre demande, vous recontacter et établir un devis. Elles ne sont ni vendues, ni partagées avec des tiers à des fins commerciales.",
    },
    {
      h: "Base légale et consentement",
      p: "Le traitement repose sur votre consentement, matérialisé par la case à cocher obligatoire du formulaire. Vous pouvez retirer ce consentement à tout moment en nous contactant.",
    },
    {
      h: "Durée de conservation",
      p: "Vos données sont conservées le temps nécessaire au traitement de votre demande et aux échanges qui en découlent, puis supprimées ou anonymisées.",
    },
    {
      h: "Vos droits",
      p: "Vous disposez d'un droit d'accès, de rectification, d'effacement et d'opposition concernant vos données personnelles. Pour exercer ces droits, contactez-nous via le formulaire du site ou sur WhatsApp.",
    },
    {
      h: "Cookies et mesure d'audience",
      p: "Le site n'utilise pas de cookies publicitaires. Un outil de mesure d'audience respectueux des règles applicables pourra être intégré pour améliorer le site ; vous en serez informé ici.",
    },
    {
      h: "Sécurité",
      p: "Nous appliquons des mesures techniques raisonnables pour protéger vos données (connexion chiffrée HTTPS, accès restreint, protection contre les soumissions abusives du formulaire).",
    },
  ],
};

const MENTIONS = {
  title: "Mentions légales",
  seo: {
    title: "Mentions légales — Koranex",
    description: "Mentions légales du site Koranex : éditeur, hébergement et propriété intellectuelle.",
  },
  sections: [
    {
      h: "Éditeur du site",
      p: "Ce site est édité par Koranex, entreprise spécialisée dans la création de sites web, le développement d'applications mobiles, le référencement naturel SEO et la maintenance de sites web. Koranex exerce son activité en ligne et accompagne des clients partout dans le monde.",
    },
    {
      h: "Nous contacter",
      p: `Vous pouvez nous joindre via le formulaire de contact du site, par e-mail à contact@kora-nex.com ou directement sur WhatsApp au ${WHATSAPP_NUMBER}.`,
    },
    {
      h: "Informations complémentaires",
      p: "Les informations légales détaillées de l'entreprise (forme juridique, adresse du siège, numéro d'immatriculation) seront publiées sur cette page prochainement.",
    },
    {
      h: "Propriété intellectuelle",
      p: "L'ensemble des contenus de ce site (textes, visuels, maquettes, identité graphique) est la propriété de Koranex. Les projets présentés comme « Concept de démonstration » sont des maquettes illustratives. Toute reproduction sans autorisation est interdite.",
    },
    {
      h: "Hébergement",
      p: "Le site est hébergé sur une infrastructure cloud sécurisée, accessible en HTTPS. Les informations détaillées de l'hébergeur seront précisées lors de la mise en production définitive.",
    },
  ],
};

export default function Legal({ type }) {
  const content = type === "privacy" ? PRIVACY : MENTIONS;
  return (
    <div data-testid={`legal-page-${type}`}>
      <Seo title={content.seo.title} description={content.seo.description} />
      <header className="py-16 md:py-20 px-6 max-w-3xl mx-auto">
        <h1 className="font-display text-4xl sm:text-6xl text-white leading-none mb-6">{content.title}</h1>
        <p className="text-sm text-slate-400">Dernière mise à jour : {new Date().toLocaleDateString("fr-FR")}</p>
      </header>
      <section className="pb-16 md:pb-24 px-6 max-w-3xl mx-auto space-y-8">
        {content.sections.map((s) => (
          <div key={s.h} className="rounded-2xl bg-[#0f172a] border border-slate-800 p-6">
            <h2 className="text-lg font-bold text-white mb-2">{s.h}</h2>
            <p className="text-sm text-slate-400 leading-relaxed">{s.p}</p>
          </div>
        ))}
        <div className="rounded-2xl border border-[#38bdf8]/30 bg-[#0f172a] p-6">
          <p className="text-sm text-slate-300">
            Une question ?{" "}
            <a
              href={WHATSAPP_LINK}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="legal-whatsapp-link"
              className="text-[#38bdf8] hover:underline"
            >
              Contactez-nous sur WhatsApp
            </a>
            .
          </p>
        </div>
      </section>
    </div>
  );
}
